export default __webpack_public_path__ + "fb67f4f74ceba4e2088f33d56574fd0c.svg";